module.exports = __webpack_public_path__ + "img/RIREKI_PLATINA.758e003d.png";